export default __webpack_public_path__ + "static/media/st-patricks-day-banner.b78cd9fe.png";